// extracted by mini-css-extract-plugin
module.exports = {"link-wrapper":"_93444fe79c--link-wrapper--Kb6Lm"};